import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import styles from './ThemeToggle.module.scss';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <motion.button
      className={styles.themeToggle}
      onClick={toggleTheme}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      transition={{ type: "spring", stiffness: 400, damping: 17 }}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
      data-theme={theme}
    >
      <motion.div
        className={styles.iconContainer}
        initial={false}
        animate={{ 
          rotate: theme === 'light' ? 0 : 180,
          scale: theme === 'light' ? 1 : 0.9
        }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      >
        {theme === 'light' ? (
          <Sun size={20} className={`${styles.icon} ${styles.lightIcon}`} />
        ) : (
          <Moon size={20} className={`${styles.icon} ${styles.darkIcon}`} />
        )}
      </motion.div>
      
      <motion.div
        className={styles.background}
        animate={{
          background: theme === 'light' 
            ? 'linear-gradient(135deg, #fde68a 0%, #f59e0b 100%)'
            : 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
        }}
        transition={{ duration: 0.3 }}
      />
      
      <span className={styles.tooltip}>
        {theme === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
      </span>
    </motion.button>
  );
};

export default ThemeToggle;
